export function isNotificationPriority(iVal) { return ['high', 'medium', 'low', 'info'].includes(iVal); }
;
//# sourceMappingURL=PICInterfaces.js.map